export const checkinList = {
  group: {
    sectionTitle: "Powiązane check-iny",
    registrationForm: "Karta meldunkowa",
    registrationFormHint: "Jeden dokument z głównym gościem i osobami towarzyszącymi",
    registrationFormEmpty: "W tej rezerwacji nie wykonano jeszcze żadnego zameldowania.",
    registrationFormError: "Nie udało się wygenerować karty. Spróbuj ponownie.",
    emptyState: "Brak powiązanych check-inów.",
    name: "Imię i nazwisko",
    phone: "Telefon",
    document: "Dokument",
    notAvailable: "Niedostępne",
    syncSent: "Wysłano do służb imigracyjnych",
    syncError: "Błąd służb imigracyjnych",
    syncPending: "Oczekuje na wysyłkę",
    moreInfo: "Więcej informacji",
    email: "E-mail",
    checkIn: "Check-in",
    checkOut: "Check-out",
    docType: "Typ dokumentu",
    supportNumber: "Numer wsparcia",
    identityVerification: "Weryfikacja tożsamości",
    tapToEnlarge: "Dotknij, aby powiększyć",
    view: "Zobacz",
    download: "Pobierz",
    selfie: "Selfie",
    minorData: "Dane małoletniego",
    relationship: "Pokrewieństwo:",
    noPhotos: "Brak załączonych zdjęć.",
    minorDocument: "Dokument małoletniego",
    authorization: "Upoważnienie",
    minorAuthorization: "Upoważnienie dla małoletniego",
    specification: "Doprecyzowanie:",
    additionalInfo: "Informacje dodatkowe",
    nationality: "Narodowość",
    birthDate: "Data urodzenia",
    ageYears: "({age} lat)",
    gender: "Płeć",
    female: "Kobieta",
    male: "Mężczyzna",
    countryResidence: "Kraj zamieszkania",
    cityResidence: "Miasto zamieszkania",
    address: "Adres",
    zipCode: "Kod pocztowy",
    sesBatchId: "ID partii SES",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "Kraj urodzenia",
    docIssuePlace: "Miejsce wydania dokumentu",
    signedDocument: "Podpisany dokument",
    edit: "Edytuj",
    remove: "Usuń",
    previewAlt: "Podgląd",
    previewFallbackTitle: "Obraz",
    docTypes: {
      passport: "Paszport",
      passportOrdinary: "Paszport zwykły",
      passportService: "Paszport służbowy",
      passportDiplomatic: "Paszport dyplomatyczny",
      idCard: "Dowód osobisty",
      nie: "NIE",
      idCardElectronic: "Elektroniczny dowód osobisty",
      idDiplomatic: "Dyplomatyczny dokument tożsamości",
      citizenshipCard: "Karta obywatelstwa",
      foreignerCard: "Karta pobytu cudzoziemca",
      drivingLicense: "Prawo jazdy",
      nauticalLicense: "Patent żeglarski",
      specialResidencePermit: "Specjalne zezwolenie na pobyt",
      foreignerDocument: "Dokument cudzoziemca",
      foreignDocument: "Dokument zagraniczny",
      diplomaticCard: "Karta dyplomatyczna",
      refugeeTravelDocument: "Dokument podróży uchodźcy",
      otherDocument: "Inny dokument",
    },
  },
  individual: {
    title: "Dane gościa",
    phone: "Telefon",
    email: "E-mail",
    notAvailable: "Niedostępne",
    lodging: "Pobyt",
    docType: "Typ dokumentu",
    docNumber: "Numer dokumentu",
    supportNumber: "Numer wsparcia",
    identityVerification: "Weryfikacja tożsamości",
    document: "Dokument",
    tapToEnlarge: "Dotknij, aby powiększyć",
    view: "Zobacz",
    download: "Pobierz",
    selfie: "Selfie",
    minorData: "Dane małoletniego",
    relationship: "Pokrewieństwo:",
    noPhotos: "Brak załączonych zdjęć.",
    minorDocument: "Dokument małoletniego",
    authorization: "Upoważnienie",
    minorAuthorization: "Upoważnienie dla małoletniego",
    specification: "Doprecyzowanie:",
    additionalInfo: "Informacje dodatkowe",
    nationality: "Narodowość",
    birthDate: "Data urodzenia",
    ageYears: "({age} lat)",
    gender: "Płeć",
    female: "Kobieta",
    male: "Mężczyzna",
    countryResidence: "Kraj zamieszkania",
    cityResidence: "Miasto zamieszkania",
    address: "Adres",
    zipCode: "Kod pocztowy",
    sesBatchId: "ID partii SES",
    alloggiatiWeb: "Alloggiati Web",
    countryBirth: "Kraj urodzenia",
    docIssuePlace: "Miejsce wydania dokumentu",
    signedDocument: "Podpisany dokument",
    edit: "Edytuj",
    previewAlt: "Podgląd",
    previewFallbackTitle: "Obraz",
    docTypes: {
      passport: "Paszport",
      passportOrdinary: "Paszport zwykły",
      passportService: "Paszport służbowy",
      passportDiplomatic: "Paszport dyplomatyczny",
      idCard: "Dowód osobisty",
      nie: "NIE",
      idCardElectronic: "Elektroniczny dowód osobisty",
      idDiplomatic: "Dyplomatyczny dokument tożsamości",
      citizenshipCard: "Karta obywatelstwa",
      foreignerCard: "Karta pobytu cudzoziemca",
      drivingLicense: "Prawo jazdy",
      nauticalLicense: "Patent żeglarski",
      specialResidencePermit: "Specjalne zezwolenie na pobyt",
      foreignerDocument: "Dokument cudzoziemca",
      foreignDocument: "Dokument zagraniczny",
      diplomaticCard: "Karta dyplomatyczna",
      refugeeTravelDocument: "Dokument podróży uchodźcy",
      otherDocument: "Inny dokument",
    },
  },
};
